// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T1hi","comment":"styles_comment__3rmUm"};